import { useEffect, useState } from "react";
import { useUserPreferences } from "../contexts/UserPreferencesContext";

export const useTheme = () => {
	const { themePreference, systemTheme } = useUserPreferences();
	const [resolvedTheme, setResolvedTheme] = useState("light");

	useEffect(() => {
		const applyThemeClass = theme => {
			const targets = [document.documentElement, document.body];
			targets.forEach(el => {
				el.classList.remove("light", "dark");
				el.classList.add(theme);
			});
		};

		// Resolve the theme based on themePreference and systemTheme
		const actual = themePreference === "system" ? systemTheme : themePreference;
		setResolvedTheme(actual);
		applyThemeClass(actual);
	}, [themePreference, systemTheme]);

	return { theme: resolvedTheme };
};
